// src/components/route/PublicRoute.js

import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
	const isAuthenticated = useSelector((state) => state.auth.user.token);

	return isAuthenticated ? <Navigate to="/" /> : children;
};

export default PublicRoute;
